import React from 'react';
import { Card } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4 lg:p-8">
      <div className="max-w-4xl mx-auto">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Button>

        <Card className="card-modern p-8">
          <h1 className="text-3xl font-bold text-foreground mb-6">Privacy Policy</h1>
          <p className="text-muted-foreground mb-4">Last updated: March 2026</p>

          <div className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Information We Collect</h2>
              <p className="text-muted-foreground">We collect information you provide directly:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Business name and contact information</li>
                <li>Account credentials (email, password)</li>
                <li>Business website and service details</li>
                <li>Payment information (processed securely via Stripe)</li>
              </ul>
              <p className="text-muted-foreground mt-3">We automatically collect:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Call logs and duration</li>
                <li>AI conversation transcripts</li>
                <li>Usage analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. How We Use Your Information</h2>
              <p className="text-muted-foreground">We use collected information to:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Provide and improve our AI receptionist services</li>
                <li>Process payments and manage subscriptions</li>
                <li>Send service notifications and alerts</li>
                <li>Customize your AI receptionist's responses</li>
                <li>Analyze usage patterns to improve the Service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. Call Recording and Transcripts</h2>
              <p className="text-muted-foreground">
                Calls handled by Front Desk Pro may be recorded and transcribed to provide call 
                history, quality assurance, and AI improvement. You are responsible for informing 
                your callers about recording in accordance with applicable laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Data Sharing</h2>
              <p className="text-muted-foreground">We do not sell your data. We share information only with:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Service providers (Twilio, Retell AI, Stripe) necessary to operate the Service</li>
                <li>Law enforcement when required by law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. Data Security</h2>
              <p className="text-muted-foreground">
                We implement industry-standard security measures to protect your data, including 
                encryption in transit and at rest. However, no system is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Your Rights</h2>
              <p className="text-muted-foreground">You have the right to:</p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your data</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Contact Us</h2>
              <p className="text-muted-foreground">
                For privacy-related inquiries, please contact us at privacy@frontdeskpro.org
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
